import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { getAppRoot } from "@/onload/loadConfig";
import { useConfig } from "@/composables/config";
import UtcDate from "@/components/UtcDate.vue";
import License from "@/components/License/License.vue";
import ExternalLink from "@/components/ExternalLink.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AboutGalaxy',
    setup(__props) {
        /* global __buildTimestamp__, __license__  */
        /* (injected by webpack) */
        const { config, isLoaded } = useConfig();
        const clientBuildDate = __buildTimestamp__ || new Date().toISOString();
        const apiDocsLink = `${getAppRoot()}api/docs`;
        const galaxyLicense = __license__;
        const versionUserDocumentationUrl = computed(() => {
            const configVal = config.value;
            return config.value.version_minor.slice(0, 3) === "dev"
                ? "https://docs.galaxyproject.org/en/latest/releases/index.html"
                : `${configVal.release_doc_base_url}${configVal.version_major}/releases/${configVal.version_major}_announce_user.html`;
        });
        return { __sfc: true, config, isLoaded, clientBuildDate, apiDocsLink, galaxyLicense, versionUserDocumentationUrl, UtcDate, License, ExternalLink };
    }
});
